import { Injectable } from '@angular/core';

@Injectable()
export class ScrollService {

    public scroll(el: Element): void {
        el.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    }
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/scroll.service.ts